import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import WaitingAreaAfterCallsContent from '../components/pages/waiting-area/after-calls/content';

function WaitingAreaAfterCallsPage(props) {
  const [originalAfterCallForm, setOriginalAfterCallForm] = useState();
  const showAfterCallsModal = useSelector((state) => state.modalReducer.showAfterCallsModal);
  const afterCallsForm = useSelector((state) => state.waitingAreaReducer.afterCallsForm);
  const isAdmin =
    useSelector((state) => state.usersReducer.userProfile) &&
    useSelector((state) => state.usersReducer.userProfile.isAdmin);

  useEffect(() => {
    setOriginalAfterCallForm(props.afterCallsForm);
  }, [props.afterCallsForm]);

  const dispatch = useDispatch();

  return (
    <div>
      <WaitingAreaAfterCallsContent
        afterCallsForm={afterCallsForm}
        originalAfterCallForm={originalAfterCallForm}
        waitingArea={props.waitingArea}
        showAfterCallsModal={showAfterCallsModal}
        updateOrView={props.updateOrView}
        isAdmin={isAdmin}
        dispatch={dispatch}
      />
    </div>
  );
}

export default WaitingAreaAfterCallsPage;
